// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/registration/v1/registration.proto" (package "agency.registration.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
/**
 * RegistrationRole declares the intended role of the registering process.
 * The harness issues NATS credentials scoped appropriately for the role.
 *
 * Wire name mapping (proto enum value → registration "role" JSON string):
 *
 * 	REGISTRATION_ROLE_CLIENT             → "client"
 * 	REGISTRATION_ROLE_HOOK_PROVIDER      → "hook-provider"
 * 	REGISTRATION_ROLE_INFERENCE_PROVIDER → "inference-provider"
 * 	REGISTRATION_ROLE_CONTEXT_PROVIDER   → "context-provider"
 * 	REGISTRATION_ROLE_TRACE_PROVIDER     → "trace-provider"
 * 	REGISTRATION_ROLE_CLIENT_PROVIDER    → "client-provider"
 * 	REGISTRATION_ROLE_SERVER             → "server"
 *
 * @generated from protobuf enum agency.registration.v1.RegistrationRole
 */
export enum RegistrationRole {
    /**
     * UNSPECIFIED is the zero value; must not be used on the wire.
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * CLIENT is for interactive user-facing agent clients.
     * Issued NATS credentials: publish ingress.<t>.<w>.*, subscribe tokens/events/URN.
     * Wire: "client"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_CLIENT = 1;
     */
    CLIENT = 1,
    /**
     * HOOK_PROVIDER is for hook, tool, and HITL provider processes.
     * Issued NATS credentials: scoped to tool, hook, and hitl subjects only.
     * No access to session-events, tokens, ingress, or audit streams.
     * Wire: "hook-provider"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_HOOK_PROVIDER = 2;
     */
    HOOK_PROVIDER = 2,
    /**
     * INFERENCE_PROVIDER is for remote LLM inference provider processes.
     * Issued NATS credentials: scoped to infer-execute (subscribe) and infer-result (publish).
     * No access to session-events, tokens, ingress, or audit streams.
     * Wire: "inference-provider"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_INFERENCE_PROVIDER = 3;
     */
    INFERENCE_PROVIDER = 3,
    /**
     * CONTEXT_PROVIDER is for external context provider processes.
     * Issued NATS credentials: scoped to KV put on atom buckets (ctx-<tenant>*) and
     * workspace config bucket (context_<tenant>_<workspace>) only.
     * No access to session-events, tokens, ingress, inference, or audit streams.
     * Wire: "context-provider"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_CONTEXT_PROVIDER = 4;
     */
    CONTEXT_PROVIDER = 4,
    /**
     * TRACE_PROVIDER is for passive trace observer processes.
     * Issued NATS credentials: subscribe-only on hook, hitl-req, hitl-res, and
     * session-events workspace subjects. No publish permissions.
     * Wire: "trace-provider"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_TRACE_PROVIDER = 5;
     */
    TRACE_PROVIDER = 5,
    /**
     * CLIENT_PROVIDER is for the client-provider daemon.
     * Issued NATS credentials: workspace-scoped publish on ingress/interrupt/cancel;
     * subscribe on tokens/session-events/partials/request-status.
     * Layer-1 JWT is required per ingress/interrupt publish (passed by caller, not stored).
     * Wire: "client-provider"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_CLIENT_PROVIDER = 6;
     */
    CLIENT_PROVIDER = 6,
    /**
     * SERVER is for the hypus-app server's TCP remote transport listener.
     * Issues a TLS server certificate (ServerAuth EKU) signed by the harness CA.
     * No NATS credentials are issued — the server already holds provider NATS credentials.
     * Wire: "server"
     *
     * @generated from protobuf enum value: REGISTRATION_ROLE_SERVER = 7;
     */
    SERVER = 7
}
